import React from "react";
import "../css/infoform.css"
import { useLanguage } from "../components/Language.js";


function InfoForm({info_num, onClose}){

    console.log("info profile form activated")

    const {language} = useLanguage();

    const translations = {
        en: {
            NoGaelic: "Little/No Gaelic",
            involved: "I don't have any Gaelic, but I'm interested in getting involved!",
            Understand: "I can understand some Gaelic, and would like to be able to speak it.",
            gettingStarted: "I'm getting started with Gaelic. I can:",
            shortSimple: "Read short, simple texts in Gaelic.",
            basicPhrase: "Understand basic phrases, e.g., hello, thank you.",
            aboutMyself: "Describe things about myself, e.g., my name, my hobbies.",
            simpleQuestions: "Ask and answer simple questions, e.g., how are you?",
            greetingsCard: "Write short messages in Gaelic, e.g., a greetings card.",
            improvingKnowledge: "I'm improving my knowledge of Gaelic. I can:",
            programmes: "Understand most TV and radio programmes in Gaelic.",
            readTheNews: "Read the news in Gaelic.",
            everydayConversations: "Have everyday conversations in Gaelic.",
            descirbesOpinions: "Describe my experiences and opinions.",
            writeSimpleTexts: "Write simple texts about my daily life and interests.",
            confidentGaelic: "I'm confident in using Gaelic. I can:",
            understandMostGaelic: "Understand most Gaelic I hear.",
            booksGaelic: "Read books in Gaelic.",
            talkMost: "Talk about most things I need to in Gaelic.",
            clearlyExpress: "Clearly express myself when writing in Gaelic.",
            addLabels: "You can add any labels that you identify with relating to the Gaelic community. Some examples of speaker labels are included below:",
            Learner: "Learner",
            Newspeaker: "New Speaker",
            GMEGraduate: "GME Graduate",
            Fluent: "Fluent",
            Native: "Native",
            noContentProvided: "no content provided",
            beginner: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            close: "Close",
            abilityHeader: "Gaelic Ability Information",
            labelHeader: "Gaelic label information",
        },
    
        gd: {
            NoGaelic: "Beagan Gàidhlig / Gun Ghàidhlig",
            involved: "Chan eil Gàidhlig agam, ach tha ùidh agam ann! ",
            Understand: "Tuigidh mi beagan Gàidhlig, agus bu mhath leam a bhith comasach a labhairt.",
            gettingStarted: "Tha mi a' tòiseachadh air Gàidhlig. Is urrainn dhomh:",
            shortSimple: "Teacsaichean goirid sìmplidh ann an Gàidhlig a leughadh ",
            basicPhrase: "Abairtean bunaiteach a thuigsinn m.e. halò, tapadh leat ",
            aboutMyself: "Iomradh a dhèanamh air nithean mum dheidhinn fhìn, m.e. m' ainm, mo chur-seachadan ",
            simpleQuestions: "Ceistean sìmplidh fhaighneachd agus a fhreagairt, m.e. Ciamar a tha thu?",
            greetingsCard: "Teachdaireachdan goirid a sgrìobhadh ann an Gàidhlig, m.e. cairt dhùrachdan",
            improvingKnowledge: "Tha mi ag adhartachadh m' eòlas air Gàidhlig. Is urrainn dhomh:",
            programmes: "A' mhòr-chuid de phrògraman TBh is rèidio ann an Gàidhlig a thuigsinn ",
            readTheNews: "Na naidheachdan a leughadh ann an Gàidhlig ",
            everydayConversations: "Còmhraidhean làitheil a chumail ann an Gàidhlig ",
            descirbesOpinions: "Iomradh a thoirt air m' eòlasan agus ùidhean",
            writeSimpleTexts: "Teacsaichean sìmplidh a sgrìobhadh mum bheatha làitheil agus ùidhean",
            confidentGaelic: "Tha mi misneachail a' cleachdadh na Gàidhlig. Is urrainn dhomh:",
            understandMostGaelic: "A' mhòr - chuid de Ghàidhlig a chluinneas mi, a thuigsinn ",
            booksGaelic: "Leabhraichean ann an Gàidhlig a leughadh",
            talkMost: "Bruidhinn mu dheidhinn na mòr-chuid de nithean air a bheil feum agam ann an Gàidhlig ",
            clearlyExpress: "Mi fhìn a dhèanamh soilleir nuair a tha mi a' sgrìobhadh ann an Gàidhlig ",
            addLabels: "Faodaidh tu leubailean as aithne dhut co-cheangailte ri coimhearsnachd na Gàidhlig a chur ris. Tha cuid de leubailean luchd-labhairt gu h-ìosal:",
            Learner: "Neach-ionnsachaidh",
            Newspeaker: "Neach-labhairt Ùr",
            GMEGraduate: "Ceumnaiche GME",
            Fluent: "Fileanta",
            Native: "Dùthchasach",
            noContentProvided: "Chan eil susbaint sam bith ann",
            beginner: "Neach-tòiseachaidh",
            intermediate: "Eadar-mheadhanach",
            advanced: "Adhartach",
            close: "Dùin",
            abilityHeader: "Fiosrachadh Comas Gàidhlig",
            labelHeader: "Fiosrachadh leubail Ghàidhlig",
        },
    };


    const getInfoContent = () => {
        switch(info_num){
            case 1:
                return <div className="info-content mt-3">
                    <h3><b>{translations[language].abilityHeader}</b></h3>
                    <h4> {translations[language].NoGaelic}</h4>
                    <p> {translations[language].involved}</p>
                    <p>{translations[language].Understand}</p>

                    <h4>{translations[language].beginner}</h4>
                    <p>{translations[language].gettingStarted} </p>
                    <ul> 
                        <li>{translations[language].shortSimple}</li>
                        <li>{translations[language].basicPhrase}</li>
                        <li>{translations[language].aboutMyself}</li>
                        <li>{translations[language].simpleQuestions}</li>
                        <li>{translations[language].greetingsCard}</li>
                    </ul>

                    <h4>{translations[language].intermediate}</h4>
                    <p>{translations[language].improvingKnowledge} </p>
                    <ul> 
                        <li>{translations[language].programmes}</li>
                        <li>{translations[language].readTheNews}</li>
                        <li>{translations[language].everydayConversations}</li>
                        <li>{translations[language].descirbesOpinions}</li>
                        <li>{translations[language].writeSimpleTexts}</li>
                    </ul>

                    <h4>{translations[language].advanced}</h4>
                    <p>{translations[language].confidentGaelic} </p>
                    <ul> 
                        <li>{translations[language].understandMostGaelic}</li>
                        <li>{translations[language].booksGaelic}</li>
                        <li>{translations[language].talkMost}</li>
                        <li>{translations[language].clearlyExpress}</li>
                    </ul>
                </div>


            case 2:
                return <div className="info-content mt-3">
                    <h3><b>{translations[language].labelHeader}</b></h3>
                    <p>{translations[language].addLabels}</p>
                    <ul> 
                        <li>{translations[language].Learner}</li>
                        <li>{translations[language].Newspeaker}</li>
                        <li>{translations[language].GMEGraduate}</li>
                        <li>{translations[language].Fluent}</li>
                        <li>{translations[language].Native}</li>
                    </ul>
                </div>


            default:
                return <p> {translations[language].noContentProvided}</p>
        }
    }

    return(

        <div className="mt-3 mb-4">
            {getInfoContent()}
            <button onClick={onClose} className="btn btn-primary btn-sm">{translations[language].close}</button>

        </div>
    );

}

export default InfoForm;